export const en = {
    test:
    {
        firstMessage: "Hello World!",
        secondMessage: "This {val}."
    }
};
